import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav-sidebar__logo-container" }
const _hoisted_2 = { class: "nav-sidebar__nav" }
const _hoisted_3 = { class: "nav-sidebar__main-nav" }
const _hoisted_4 = { class: "nav-sidebar__nav-item-label" }
const _hoisted_5 = { class: "nav-sidebar__nav-item-text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "nav-sidebar__nav-item-icon icon icon--logout--thin" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "nav-sidebar__nav-item-text" }, " Log out ", -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "nav-sidebar__sub-nav"
}
const _hoisted_10 = { class: "nav-sidebar__profile-info" }
const _hoisted_11 = { class: "nav-sidebar__profile-name" }
const _hoisted_12 = {
  key: 0,
  class: "nav-sidebar__profile-role"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ProfilePictureComponent = _resolveComponent("ProfilePictureComponent")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-sidebar-wrapper", [
			{ 'nav-sidebar-wrapper--hidden': !$props.showNav },
			{ 'nav-sidebar-wrapper--expand': $setup.expand_nav }
		]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["nav-sidebar", { 'nav-sidebar--expand': $setup.expand_nav }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: $options.home_route,
          class: "nav-sidebar__logo"
        }, null, 8 /* PROPS */, ["to"]),
        _createVNode(_component_router_link, {
          to: $options.home_route,
          class: "nav-sidebar__mini-logo"
        }, null, 8 /* PROPS */, ["to"])
      ]),
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filtered_navigation, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.route
              }, [
                _createVNode(_component_router_link, {
                  to: { name: item.route },
                  class: _normalizeClass(["nav-sidebar__nav-item", [
									{ 'nav-sidebar__nav-item--active': $options.isActiveRoute( item.route ) },
								]])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", {
                        class: _normalizeClass(`nav-sidebar__nav-item-icon icon icon--${item.icon}`)
                      }, null, 2 /* CLASS */),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1 /* TEXT */)
                    ]),
                    _withDirectives(_createElementVNode("span", { class: "nav-sidebar__nav-item-notifications" }, _toDisplayString($setup.all_notifications_pagination.user_related_pending_count), 513 /* TEXT, NEED_PATCH */), [
                      [_vShow, item.route === 'notifications' && $setup.all_notifications_pagination.user_related_pending_count]
                    ])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "nav-sidebar__nav-item",
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.logoutUser && $options.logoutUser(...args)))
              }, _hoisted_8)
            ])
          ])
        ]),
        (!!$setup.user_profile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_ProfilePictureComponent, { user: $setup.user_profile }, null, 8 /* PROPS */, ["user"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString($setup.user_profile.fullName), 1 /* TEXT */),
                ($setup.user_profile.user_role)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString($setup.user_profile.user_role), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */),
    _createElementVNode("button", {
      class: "nav-sidebar__toggle",
      onClick: _cache[1] || (_cache[1] = (...args) => ($setup.toggleNavExpand && $setup.toggleNavExpand(...args)))
    })
  ], 2 /* CLASS */))
}